import React from "react";

import {
  ImageOne,
  ImageTwo,
  ImageThree,
  ImageFour,
  ImageFive,
  ImageSix,
  ImageSeven,
  ImageEight,
  ImageNine,
  EmojiOne,
  EmojiTwo,
  AtlassianOne,
  AtlassianTwo,
  StepsOne,
  StepsTwo,
  StepsThree,
  NumberOne,
  NumberTwo,
  TextOne,
  TextTwo,
  NumberThree,
} from "@caelor/ui";

import { CARD_DESIGN } from "../../../../settings/features/cards/defaults";
import { useCardsStore } from "../../../../../../../stores/use-cards-store";

const designComponents = {
  [CARD_DESIGN.IMAGE_ONE]: ImageOne,
  [CARD_DESIGN.IMAGE_TWO]: ImageTwo,
  [CARD_DESIGN.IMAGE_THREE]: ImageThree,
  [CARD_DESIGN.IMAGE_FOUR]: ImageFour,
  [CARD_DESIGN.IMAGE_FIVE]: ImageFive,
  [CARD_DESIGN.IMAGE_SIX]: ImageSix,
  [CARD_DESIGN.IMAGE_SEVEN]: ImageSeven,
  [CARD_DESIGN.IMAGE_EIGHT]: ImageEight,
  [CARD_DESIGN.IMAGE_NINE]: ImageNine,
  [CARD_DESIGN.EMOJI_ONE]: EmojiOne,
  [CARD_DESIGN.EMOJI_TWO]: EmojiTwo,
  [CARD_DESIGN.ATLASSIAN_ONE]: AtlassianOne,
  [CARD_DESIGN.ATLASSIAN_TWO]: AtlassianTwo,
  [CARD_DESIGN.STEPS_ONE]: StepsOne,
  [CARD_DESIGN.STEPS_TWO]: StepsTwo,
  [CARD_DESIGN.STEPS_THREE]: StepsThree,
  [CARD_DESIGN.NUMBER_ONE]: NumberOne,
  [CARD_DESIGN.NUMBER_TWO]: NumberTwo,
  [CARD_DESIGN.NUMBER_THREE]: NumberThree,
  [CARD_DESIGN.TEXT_ONE]: TextOne,
  [CARD_DESIGN.TEXT_TWO]: TextTwo,
};

const Design = ({ config, data, isEditable = false, index }) => {
  const DesignComponent = designComponents[config?.design];

  const updateCardData = useCardsStore((state) => state.updateCardData);
  const card = useCardsStore((state) => state.card);

  const textCardProps = [CARD_DESIGN.TEXT_ONE, CARD_DESIGN.TEXT_TWO].includes(
    config?.design
  )
    ? {
        hasBubbleEditor: isEditable,
      }
    : {};

  return (
    <DesignComponent
      index={index}
      data={data}
      config={config}
      isEditable={isEditable}
      updateCardData={(data) => {
        if (card) {
          updateCardData(data);
        }
      }}
      {...textCardProps}
    />
  );
};

export default Design;
